import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AuthService } from '../auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class MailCenterService {
  token: string = "";
  constructor(private fns: AngularFireFunctions, private auth: AuthService) { }


  sendStatusUpdate(name: string, inventionName: string, status: string, share: any, mail: string,time:number) {
    let percentageText = "'. Buluştaki payınız " + share + "/100'dür ";
    if (share === 0) { percentageText = "" };
    return this.fns.httpsCallable('genericEmail')({ name: name, sendTime: time, text: inventionName + ` adlı buluşunuzun durumu: ` + status + percentageText + ".", email: ["patentchest@gmail.com", mail,this.auth.userMail], passwordpreheader: "Patentinizin son durumu hk." })
     }
     demandforrightReminder(inventionDate:any,inventionName: string, status: string, time:object) {
      console.log(inventionDate);
      const day= inventionDate.slice(-2);
      const month= inventionDate.slice(5,-3);
      const year=inventionDate.slice(0,4);
      console.log(day, month,year);
      return this.fns.httpsCallable('sendLater')({ sendTime: time, text: inventionName + ` adlı buluşunuza ilişkin hak sahipliği kararının buluş bildirim tarihinden (${day}-${month}-${year}'den) itibaren 2 ay içinde verilmesi gerekmektedir. Hak talebi durumu girildiyse bu mesajı dikkate almayınız.`, email: [this.auth.userMail], passwordpreheader: "Patentinizin son durumu hk." })
       }
      countryDecisionReminder(inventionDate:any,inventionName: string, status: string, time:object) {
        console.log(inventionDate);
        const day= inventionDate.slice(-2);
        const month= inventionDate.slice(5,-3);
        const year=inventionDate.slice(0,4);
        console.log(day, month,year);
        return this.fns.httpsCallable('internationalDecision')({ sendTime: time, text: inventionName + ` adlı buluşunuza ilişkin yurt dışına çıkış kararının ilk patent başvuru tarihinden (${day}-${month}-${year}'den) itibaren 1 yıl içinde verilmesi gerekmektedir.`, email: [this.auth.userMail], passwordpreheader: "Patentinizin son durumu hk." })
         }
         PCTReminder(inventionDate:any,inventionName: string, status: string, time:object) {
          console.log(inventionDate);
          const day= inventionDate.slice(-2);
          const month= inventionDate.slice(5,-3);
          const year=inventionDate.slice(0,4);
          console.log(day, month,year);
          return this.fns.httpsCallable('PCTDecision')({ sendTime: time, text: inventionName + ` adlı buluşunuza ilişkin PCT ülke çıkış kararının ilk patent başvuru tarihinden (${day}-${month}-${year}'den) itibaren 2,5 yıl içinde verilmesi gerekmektedir. Buluşa ilişkin PCT girişi yapılmamışsa lütfen bu maili dikkate almayınız.`, email: [this.auth.userMail], passwordpreheader: "Patentinizin son durumu hk." })
           }
           jobReminder(terminationDate:any,jobName: string, time:object) {
            console.log(terminationDate);
            const day= terminationDate.slice(-2);
            const month= terminationDate.slice(5,-3);
            const year=terminationDate.slice(0,4);
            console.log(day, month,year);
            return this.fns.httpsCallable('jobReminder')({ sendTime: time, text: jobName + ` adlı çalışmanıza ilişkin belirtilen son tarih: ${day}-${month}-${year}. İlgili işleme ilişkin işlem tamamlanmışsa lütfen bu maili dikkate almayınız.`, email: [this.auth.userMail], passwordpreheader: "İş Kaydınız Hk." })
             }
}

